import { Link } from "react-router-dom";
import { Mail, Clock } from "lucide-react";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { InnerBlock } from "@/components/InnerBlock";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { ContactForm } from "@/pages/sections/ContactForm";
import { WhatHappensNext } from "@/pages/sections/WhatHappensNext";
import { useI18n } from "@/lib/i18n";

export default function CompanyContactPage() {
  const { t } = useI18n();
  return (
    <div data-testid="company-contact-page">
      <Seo title="Contact Wafa Solutions" description="Talk to an engineer about your project. Book a free 30-minute scoping call or send your requirement." />
      <PageHero
        eyebrow="Contact"
        h1="Let's talk about what you are building."
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "Company", to: "/company" }, { label: "Contact" }]}
      />

      <InnerBlock tint="white" heading="Two ways to start">
        <div className="grid gap-5 md:grid-cols-2">
          <div className="rounded-lg border border-wafa-deep/10 bg-wafa-cream/40 p-6">
            <div className="font-heading text-lg font-semibold text-wafa-deep">Book a call</div>
            <p className="mt-2 text-sm text-wafa-ink/75">Thirty minutes with an engineer, not a salesperson.</p>
            <Link to="#contact-form" className="mt-4 inline-flex items-center rounded-md bg-wafa-primary px-4 py-2 text-sm font-semibold text-white hover:bg-wafa-deep">
              Scroll to form
            </Link>
          </div>
          <div className="rounded-lg border border-wafa-deep/10 bg-white p-6">
            <div className="font-heading text-lg font-semibold text-wafa-deep">Send your requirement</div>
            <p className="mt-2 text-sm text-wafa-ink/75">Through the form below. We reply within one business day.</p>
          </div>
        </div>
      </InnerBlock>

      <InnerBlock tint="cream" heading="Talk to us directly">
        <div className="grid gap-4 md:grid-cols-2">
          <a
            href={`mailto:${t.contact.email}`}
            data-testid="company-contact-email"
            className="flex items-center gap-3 rounded-lg border border-wafa-deep/10 bg-white p-5 hover:-translate-y-1 transition-transform"
          >
            <Mail className="h-4 w-4 text-wafa-primary" />
            <span className="font-heading text-lg font-semibold text-wafa-deep">{t.contact.email}</span>
          </a>
          <div
            data-testid="company-contact-whatsapp"
            className="flex items-center justify-between gap-4 rounded-lg border border-wafa-deep/10 bg-white p-5"
          >
            <div>
              <div className="text-xs uppercase tracking-wider text-wafa-ink/60">WhatsApp</div>
              <div className="mt-1 font-heading text-lg font-semibold text-wafa-deep">Chat with us</div>
            </div>
            <WhatsAppButton source="company_contact" />
          </div>
        </div>
        <div className="mt-4 flex items-center gap-3 rounded-lg border border-wafa-deep/10 bg-white p-5">
          <Clock className="h-4 w-4 text-wafa-primary" />
          <span className="text-sm text-wafa-ink/80">
            Sunday to Thursday, Oman time. Support clients on the Critical plan reach us any time.
          </span>
        </div>
      </InnerBlock>

      <div id="contact-form">
        <ContactForm />
      </div>
      <WhatHappensNext />
    </div>
  );
}
